function factory({ window, document, thn }) {

  const engine = {};

  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const $ = window.jQuery;
      const langPattern = {
        العربيّة: 'ar',
        'English (US)': 'en',
        简体中文: 'zh',
      };

      /* Get language from the selector (only available way) */
      let aux = $ && $('select[ng-model=currentLanguage]>option:selected').text();
      if (aux && aux.length) {
        aux = langPattern[aux];
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }
      }

      aux = window.location.pathname.slice(1, 3);

      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      reject('no_language');
    });
  };

  engine.boot = function boot() {
    const $ = window.jQuery;
    let $loader;

    if (!thn.loaderObv) {

      $loader = $ && $('.loader-container');

      if ($loader && $loader.length) {
        // Define page update function
        thn.loaderObv = thn.debounce(function thnLoaderObv() {
          if (!$('#loader').is('visible')) {
            thn.languageCheck();
          }
        }, 250);

        // Start observation
        thn.observeDom($loader.get(0), thn.loaderObv, {
          childList: true,
          subtree: true,
          characterData: false,
          attributes: true,
        });
      }
    }
  };

  return engine;
}

export { factory };
